import React from 'react';
import { Shield, CheckCircle, Award } from 'lucide-react';

const HeroSection = ({ onOpenForm }) => {
  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-32 pb-20 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-primary via-primary to-gray-900 opacity-95"></div>
        <img
          src="https://images.unsplash.com/photo-1749648329134-75ed14f7dae5"
          alt="Professional trademark services"
          className="w-full h-full object-cover opacity-20"
        />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-white">
            <div className="inline-block mb-4">
              <span className="bg-secondary text-white px-4 py-2 rounded-full text-sm font-semibold">
                USPTO Filing Experts
              </span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6">
              <span className="text-white">Protect Your Brand with</span>
              <span className="text-secondary"> Professional Trademark Registration</span>
            </h1>
            
            <p className="text-lg md:text-xl text-gray-300 mb-8 leading-relaxed">
              Secure your business name, logo, and brand identity with expert USPTO trademark filing services. We've successfully registered over 1000+ trademarks for businesses nationwide.
            </p>

            {/* Trust Badges */}
            <div className="grid grid-cols-3 gap-4 mb-8">
              <div className="text-center">
                <div className="flex justify-center mb-2">
                  <Shield className="text-secondary" size={32} />
                </div>
                <div className="text-2xl font-bold">1000+</div>
                <div className="text-sm text-gray-400">Trademarks Filed</div>
              </div>
              <div className="text-center">
                <div className="flex justify-center mb-2">
                  <CheckCircle className="text-secondary" size={32} />
                </div>
                <div className="text-2xl font-bold">95%</div>
                <div className="text-sm text-gray-400">Approval Rate</div>
              </div>
              <div className="text-center">
                <div className="flex justify-center mb-2">
                  <Award className="text-secondary" size={32} />
                </div>
                <div className="text-2xl font-bold">15+</div>
                <div className="text-sm text-gray-400">Years Experience</div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={onOpenForm}
                className="bg-secondary text-white px-8 py-4 rounded-md hover:bg-secondary/90 transition-all font-semibold shadow-lg hover:shadow-xl text-lg"
              >
                Register My Trademark
              </button>
              <button
                onClick={() => document.getElementById('pricing').scrollIntoView({ behavior: 'smooth' })}
                className="bg-white text-primary px-8 py-4 rounded-md hover:bg-accent transition-all font-semibold shadow-lg text-lg"
              >
                View Pricing
              </button>
            </div>

            {/* Urgency Message */}
            <div className="mt-6 flex items-center space-x-2 text-secondary">
              <CheckCircle size={20} />
              <span className="text-sm font-medium">Limited Time: Free Trademark Search Included</span>
            </div>
          </div>

          {/* Right Content - Image */}
          <div className="hidden lg:block">
            <div className="relative">
              <div className="absolute -inset-4 bg-secondary/20 rounded-lg blur-xl"></div>
              <img
                src="https://images.pexels.com/photos/5668806/pexels-photo-5668806.jpeg"
                alt="Professional legal consultation"
                className="relative rounded-lg shadow-2xl w-full h-[500px] object-cover"
              />
              
              {/* Floating Stats Card */}
              <div className="absolute bottom-8 -left-8 bg-white p-6 rounded-lg shadow-xl">
                <div className="text-primary text-3xl font-bold">5000+</div>
                <div className="text-gray-600 text-sm">Satisfied Clients</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-secondary rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-secondary rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
